package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.ui.Alignment
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.ShoppingCart
import androidx.compose.material.icons.filled.Star
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.data.JsonMap
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardEstoque
import br.com.htms.inspeccaocampo.ui.dashboards.EstoqueDash
import br.com.htms.inspeccaocampo.ui.dashboards.MovDash
import br.com.htms.inspeccaocampo.ui.dashboards.PatDash
import br.com.htms.inspeccaocampo.ui.dashboards.SaldoDash
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.OrdemColuna
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalhoOrdenavel
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.kit.Ordenacao
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.kit.rememberOrdem
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.SeletorBusca
import kotlinx.coroutines.launch

private enum class AbaEstoque(val rotulo: String) { DASH("Dashboard"), SALDO("Saldos"), MOV("Adicionar"), PAT("Patrimônio"), HIST("Movimentos") }

private data class EstItem(val id: String, val nome: String, val unidade: String, val categoria: String)
private data class EstSaldo(val itemId: String, val cc: String, val obra: String, val qtd: Double, val situacao: String)
private data class EstMov(val id: String, val data: String, val tipo: String, val item: String, val qtd: Double, val cc: String, val obra: String, val destino: String, val responsavel: String)
private data class EstPat(val id: String, val nome: String, val tipo: String, val identificacao: String, val posse: String, val empresa: String, val chegada: String, val contrato: String, val cc: String, val obra: String, val situacao: String)
private data class EstOpt(val id: String, val rotulo: String)
private data class EstDados(
    val itens: List<EstItem>,
    val saldos: List<EstSaldo>,
    val movs: List<EstMov>,
    val patrimonio: List<EstPat>,
    val centros: List<EstOpt>,
    val colaboradores: List<EstOpt>,
    val podeEditar: Boolean,
    val podeExcluir: Boolean
)

private fun js(s: String) = buildString {
    append('"')
    for (c in s) when (c) {
        '\\' -> append("\\\\"); '"' -> append("\\\""); '\n' -> append(" ")
        else -> append(c)
    }
    append('"')
}

private fun rotuloCat(c: String) = when (c) {
    "EPI" -> "EPI"; "MOVEL" -> "Móvel"; "INFORMATICA" -> "Informática"
    "MATERIAL_LT" -> "Material de linha"; "MAQUINA" -> "Máquina"; else -> "Outro"
}

private fun qtdTxt(v: Double): String {
    val i = v.toLong()
    return if (v == i.toDouble()) i.toString() else v.toString().replace('.', ',')
}

private fun parseDados(raw: String): EstDados {
    val o = JsonMap.parse(raw)
    fun obj(a: Any?) = a as? JsonMap
    return EstDados(
        itens = o.array("itens").orEmpty().mapNotNull { obj(it)?.let { j -> EstItem(j.str("id"), j.str("nome"), j.str("unidade"), j.str("categoria")) } },
        saldos = o.array("saldos").orEmpty().mapNotNull { obj(it)?.let { j ->
            EstSaldo(j.str("item_id"), j.str("cc_codigo"), j.str("obra_nome"), j.double("qtd") ?: 0.0, j.str("situacao"))
        } },
        movs = o.array("movs").orEmpty().mapNotNull { obj(it)?.let { j ->
            val dest = listOf(j.str("cc_destino"), j.str("obra_destino")).filter { it.isNotBlank() }.joinToString(" - ")
            EstMov(j.str("id"), j.str("data"), j.str("tipo"), j.str("item_nome"), j.double("qtd") ?: 0.0, j.str("cc_codigo"), j.str("obra_nome"), dest, j.str("responsavel"))
        } },
        patrimonio = o.array("patrimonio").orEmpty().mapNotNull { obj(it)?.let { j ->
            EstPat(j.str("id"), j.str("nome"), j.str("tipo"), j.str("identificacao"), j.str("posse"), j.str("empresa"), j.str("chegada"), j.str("contrato"), j.str("cc_codigo"), j.str("obra_nome"), j.str("situacao"))
        } },
        centros = o.array("centros").orEmpty().mapNotNull { obj(it)?.let { j -> EstOpt(j.str("codigo"), j.str("codigo") + " - " + j.str("nome")) } },
        colaboradores = o.array("colaboradores").orEmpty().mapNotNull { obj(it)?.let { j -> EstOpt(j.str("id"), j.str("nome")) } },
        podeEditar = o.bool("podeEditar"),
        podeExcluir = o.bool("podeExcluir")
    )
}


private fun estoqueDashDe(d: EstDados): EstoqueDash {
    val nomes = d.itens.associateBy { it.id }
    return EstoqueDash(
        itens = d.itens.size,
        centros = d.centros.map { it.id to it.rotulo },
        saldos = d.saldos.map { s -> SaldoDash(nomes[s.itemId]?.categoria ?: "", s.cc, s.obra, s.qtd, s.situacao) },
        movs = d.movs.map { m -> MovDash(m.data, m.tipo, m.item, m.qtd, m.cc, m.obra, m.destino) },
        pats = d.patrimonio.map { p -> PatDash(p.posse, p.cc, p.obra, p.situacao) }
    )
}
@Composable
fun SharedEstoqueScreen(controller: AppController) {
    var aba by remember { mutableStateOf(AbaEstoque.DASH) }
    var tipoMov by remember { mutableStateOf("ENTRADA") }
    var dados by remember { mutableStateOf<EstDados?>(null) }
    var erro by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()
    fun carregar() {
        scope.launch {
            AuthApi.apiJson("GET", "/estoque/dados")
                .onSuccess { dados = parseDados(it); erro = null }
                .onFailure { erro = it.message ?: "Falha ao carregar o estoque." }
        }
    }
    LaunchedEffect(Unit) { carregar() }
    val d = dados
    val menu = AbaEstoque.entries.map {
        val icone = when (it) {
            AbaEstoque.DASH -> Icons.Filled.Star
            AbaEstoque.SALDO -> Icons.Filled.ShoppingCart
            AbaEstoque.MOV -> Icons.Filled.Add
            AbaEstoque.PAT -> Icons.Filled.Build
            AbaEstoque.HIST -> Icons.Filled.DateRange
        }
        PortalMenuItem(it.name, it.rotulo, icone)
    }
    PortalModulo("Estoque", menu, aba.name, { aba = AbaEstoque.valueOf(it) }) { largo ->
        erro?.let { Text(it, color = PortalCores.Vermelho) }
        if (d == null && erro == null) Text("Carregando...", color = PortalCores.CinzaTexto)
        if (d != null) when (aba) {
            AbaEstoque.DASH -> DashboardEstoque(estoqueDashDe(d), onAtualizar = { carregar() })
            AbaEstoque.SALDO -> AbaSaldos(d, { tipoMov = it; aba = AbaEstoque.MOV }, { aba = AbaEstoque.PAT })
            AbaEstoque.MOV -> AbaMov(d, tipoMov, largo) { carregar() }
            AbaEstoque.PAT -> AbaPat(d, largo) { carregar() }
            AbaEstoque.HIST -> AbaHist(d) { carregar() }
        }
    }
}

private data class LinhaSaldo(
    val nome: String,
    val categoria: String,
    val unidade: String,
    val situacao: String,
    val cc: String,
    val obra: String,
    val qtd: Double
)

@Composable
private fun AbaSaldos(d: EstDados, onLancar: (String) -> Unit, onEquipamento: () -> Unit) {
    var busca by remember { mutableStateOf("") }
    var cc by remember { mutableStateOf("") }
    var cat by remember { mutableStateOf("") }
    var sit by remember { mutableStateOf("") }
    val ordem = rememberOrdem("ITEM")
    val nomes = d.itens.associateBy { it.id }
    val linhasBase = d.saldos.map { s ->
        val item = nomes[s.itemId]
        LinhaSaldo(
            nome = item?.nome ?: s.itemId,
            categoria = rotuloCat(item?.categoria ?: ""),
            unidade = item?.unidade?.ifBlank { "UN" } ?: "UN",
            situacao = s.situacao.ifBlank { "—" },
            cc = s.cc,
            obra = s.obra,
            qtd = s.qtd
        )
    }
    val cats = linhasBase.map { it.categoria }.filter { it.isNotBlank() }.distinct().sorted()
    val sits = linhasBase.map { it.situacao }.distinct().sorted()
    val centros = (d.centros.map { it.id to it.rotulo } + linhasBase.map { it.cc }.filter { it.isNotBlank() }.distinct().map { cod ->
        val obra = linhasBase.firstOrNull { it.cc == cod }?.obra.orEmpty()
        cod to if (obra.isBlank()) cod else "$cod - $obra"
    }).distinctBy { it.first }.sortedBy { it.second }
    val termos = busca.trim().split(Regex("\\s+")).filter { it.isNotEmpty() }
    val filtradas = linhasBase.filter { l ->
        (cc.isBlank() || l.cc == cc) &&
            (cat.isBlank() || l.categoria == cat) &&
            (sit.isBlank() || l.situacao == sit) &&
            termos.all { t ->
                Ordenacao.contem(l.nome, t) || Ordenacao.contem(l.categoria, t) ||
                    Ordenacao.contem(l.unidade, t) || Ordenacao.contem(l.situacao, t) ||
                    Ordenacao.contem(l.cc, t) || Ordenacao.contem(l.obra, t) ||
                    Ordenacao.contem(qtdTxt(l.qtd), t)
            }
    }
    val cmp = when (ordem.col) {
        "QTD" -> Ordenacao.porNumero(ordem.asc) { it: LinhaSaldo -> it.qtd }
        "CAT" -> Ordenacao.por(ordem.asc) { it: LinhaSaldo -> it.categoria }
        "UN" -> Ordenacao.por(ordem.asc) { it: LinhaSaldo -> it.unidade }
        "SIT" -> Ordenacao.por(ordem.asc) { it: LinhaSaldo -> it.situacao }
        "CC" -> Ordenacao.por(ordem.asc) { it: LinhaSaldo -> it.cc }
        "OBRA" -> Ordenacao.por(ordem.asc) { it: LinhaSaldo -> it.obra }
        else -> Ordenacao.por(ordem.asc) { it: LinhaSaldo -> it.nome }
    }
    val linhas = filtradas.sortedWith(if (ordem.col == "ITEM") cmp else cmp.thenBy { it.nome })
    val temFiltro = busca.isNotBlank() || cc.isNotBlank() || cat.isNotBlank() || sit.isNotBlank()
    CartaoSecao(
        titulo = "Saldo por obra",
        subtitulo = "${d.itens.size} itens · ${d.saldos.map { it.cc }.distinct().size} centros de custo. Dados das planilhas de gerenciamento, do inventário 3012 e das máquinas da 3008."
    ) {
        Row(Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            if (d.podeEditar) {
                PortalButton(onClick = { onLancar("ENTRADA") }) { Text("Nova entrada") }
                PortalButton(onClick = { onLancar("SAIDA") }) { Text("Nova sa\u00edda") }
                PortalButton(onClick = { onLancar("TRANSFERENCIA") }) { Text("Transferir") }
                PortalButton(onClick = onEquipamento) { Text("Novo equipamento") }
            } else {
                Text("Consulta apenas. Para adicionar, pe\u00e7a a edi\u00e7\u00e3o do m\u00f3dulo Estoque.", color = PortalCores.CinzaTexto)
            }
        }
        Campo("Buscar item, obra, categoria ou situação", busca) { busca = it }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            Box(Modifier.weight(1.5f)) {
                Seletor("Centro de custo", listOf("" to "Todos os centros") + centros, cc, { cc = it }, embutido = true)
            }
            Box(Modifier.weight(1f)) {
                Seletor("Categoria", listOf("" to "Todas") + cats.map { it to it }, cat, { cat = it }, embutido = true)
            }
            Box(Modifier.weight(1f)) {
                Seletor("Situação", listOf("" to "Todas") + sits.map { it to it }, sit, { sit = it }, embutido = true)
            }
        }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
            Text("${linhas.size} de ${d.saldos.size}", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
            if (temFiltro) TextButton(onClick = { busca = ""; cc = ""; cat = ""; sit = "" }) { Text("Limpar filtros") }
        }
        Box(Modifier.fillMaxWidth().horizontalScroll(rememberScrollState())) {
            Column(Modifier.width(1080.dp)) {
                TabelaPortal(cabecalho = {
                    CelulaCabecalhoOrdenavel("Item", 2.4f, ordem.marca("ITEM")) { ordem.clique("ITEM") }
                    CelulaCabecalhoOrdenavel("Categoria", 1.15f, ordem.marca("CAT")) { ordem.clique("CAT") }
                    CelulaCabecalhoOrdenavel("Un.", 0.55f, ordem.marca("UN")) { ordem.clique("UN") }
                    CelulaCabecalhoOrdenavel("Situação", 0.9f, ordem.marca("SIT")) { ordem.clique("SIT") }
                    CelulaCabecalhoOrdenavel("CC", 0.55f, ordem.marca("CC")) { ordem.clique("CC") }
                    CelulaCabecalhoOrdenavel("Obra", 1.8f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
                    CelulaCabecalhoOrdenavel("Qtd", 0.55f, ordem.marca("QTD")) { ordem.clique("QTD") }
                }) {
                    if (linhas.isEmpty()) {
                        Text(
                            "Nenhum item com esses filtros.",
                            modifier = Modifier.padding(16.dp),
                            color = PortalCores.CinzaTexto
                        )
                    }
                    linhas.forEach { l ->
                        LinhaTabela {
                            Celula(l.nome, 2.4f, negrito = true, cor = PortalCores.Navy, linhas = 6)
                            Celula(l.categoria, 1.15f)
                            Celula(l.unidade, 0.55f)
                            Celula(l.situacao, 0.9f)
                            Celula(l.cc, 0.55f)
                            Celula(l.obra, 1.8f, linhas = 4)
                            Celula(qtdTxt(l.qtd), 0.55f, negrito = true, cor = if (l.qtd <= 0) PortalCores.Vermelho else PortalCores.Verde)
                        }
                    }
                }
            }
        }
    }
}

private fun dataBr(s: String): String {
    val p = s.split("-")
    return if (p.size == 3 && p[0].length == 4) "${p[2]}/${p[1]}/${p[0]}" else s.ifBlank { "—" }
}

private fun rotuloTipo(t: String) = when (t) {
    "ENTRADA" -> "Entrada"
    "SAIDA" -> "Saída"
    "TRANSFERENCIA" -> "Transferência"
    else -> t.ifBlank { "—" }
}

private fun rotuloPosse(p: String) = when (p.uppercase()) {
    "PROPRIO" -> "Próprio"
    "ALUGADO" -> "Alugado"
    else -> p.ifBlank { "—" }
}

@Composable
private fun AbaMov(d: EstDados, tipoInicial: String, largo: Boolean, onOk: () -> Unit) {
    if (!d.podeEditar) {
        Text("Seu usuário pode consultar o estoque. Para lançar, peça a edição do módulo.", color = PortalCores.CinzaTexto)
        return
    }
    var tipo by remember(tipoInicial) { mutableStateOf(tipoInicial) }
    var itemId by remember { mutableStateOf("") }
    var nomeNovo by remember { mutableStateOf("") }
    var un by remember { mutableStateOf("UN") }
    var cat by remember { mutableStateOf("EPI") }
    var qtd by remember { mutableStateOf("") }
    var cc by remember { mutableStateOf("") }
    var dest by remember { mutableStateOf("") }
    var colab by remember { mutableStateOf("") }
    var data by remember { mutableStateOf("") }
    var obs by remember { mutableStateOf("") }
    var msg by remember { mutableStateOf<String?>(null) }
    var ok by remember { mutableStateOf(true) }
    var gravando by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    val tipos = listOf("ENTRADA" to "Entrada", "SAIDA" to "Saída", "TRANSFERENCIA" to "Transferência")
    val cats = listOf(
        "EPI" to "EPI", "MOVEL" to "Móvel", "INFORMATICA" to "Informática",
        "MATERIAL_LT" to "Material de linha", "MAQUINA" to "Máquina", "OUTRO" to "Outro"
    )
    CartaoSecao(
        titulo = "Adicionar no estoque",
        subtitulo = "Entrada soma na obra. Saída baixa o saldo. Transferência muda o item de uma obra para outra."
    ) {
        Par(largo,
            { m -> Seletor("Tipo", tipos, tipo, { tipo = it }, modifier = m, embutido = true) },
            { m ->
                SeletorBusca(
                    "Item do cadastro",
                    listOf("" to "Novo item") + d.itens.map { it.id to it.nome },
                    itemId, { itemId = it }, modifier = m, embutido = true
                )
            }
        )
        if (itemId.isBlank()) {
            Campo("Nome do novo item", nomeNovo, onChange = { nomeNovo = it })
            Par(largo,
                { m -> Campo("Unidade", un, modifier = m, onChange = { un = it }) },
                { m -> Seletor("Categoria", cats, cat, { cat = it }, modifier = m, embutido = true) }
            )
        }
        Par(largo,
            { m ->
                Campo("Quantidade", qtd, numero = true, modifier = m, onChange = {
                    qtd = it.filter { c -> c.isDigit() || c == ',' || c == '.' }
                })
            },
            { m ->
                SeletorBusca(
                    "Centro de custo / obra",
                    d.centros.map { it.id to it.rotulo },
                    cc, { cc = it }, modifier = m, embutido = true
                )
            }
        )
        if (tipo == "TRANSFERENCIA") {
            SeletorBusca(
                "Obra de destino",
                d.centros.map { it.id to it.rotulo },
                dest, { dest = it }, embutido = true
            )
        }
        Par(largo,
            { m ->
                SeletorBusca(
                    "Responsável",
                    listOf("" to "Sem responsável") + d.colaboradores.map { it.id to it.rotulo },
                    colab, { colab = it }, modifier = m, embutido = true
                )
            },
            { m -> Campo("Data (aaaa-mm-dd)", data, modifier = m, onChange = { data = it }) }
        )
        Campo("Observação", obs, onChange = { obs = it })
        msg?.let { Text(it, color = if (ok) PortalCores.Verde else PortalCores.Vermelho) }
        PortalButton(onClick = {
            val n = qtd.replace(',', '.').toDoubleOrNull()
            if (n == null || n <= 0) { ok = false; msg = "Informe a quantidade."; return@PortalButton }
            gravando = true
            val body = buildString {
                append('{')
                append("\"tipo\":").append(js(tipo)).append(',')
                append("\"itemId\":").append(js(itemId)).append(',')
                append("\"nome\":").append(js(nomeNovo)).append(',')
                append("\"unidade\":").append(js(un)).append(',')
                append("\"categoria\":").append(js(cat)).append(',')
                append("\"qtd\":").append(n).append(',')
                append("\"ccCodigo\":").append(js(cc)).append(',')
                append("\"ccDestino\":").append(js(dest)).append(',')
                append("\"funcionarioId\":").append(js(colab)).append(',')
                append("\"data\":").append(js(data)).append(',')
                append("\"obs\":").append(js(obs))
                append('}')
            }
            scope.launch {
                AuthApi.apiJson("POST", "/estoque/mov", body)
                    .onSuccess { ok = true; msg = "Movimentação gravada."; qtd = ""; nomeNovo = ""; onOk() }
                    .onFailure { ok = false; msg = it.message ?: "Falha ao gravar." }
                gravando = false
            }
        }, enabled = !gravando) { Text(if (gravando) "Salvando..." else "Adicionar ao estoque") }
    }
}

@Composable
private fun AbaPat(d: EstDados, largo: Boolean, onOk: () -> Unit) {
    var nome by remember { mutableStateOf("") }
    var ident by remember { mutableStateOf("") }
    var posse by remember { mutableStateOf("PROPRIO") }
    var empresa by remember { mutableStateOf("") }
    var cc by remember { mutableStateOf("") }
    var msg by remember { mutableStateOf<String?>(null) }
    var busca by remember { mutableStateOf("") }
    var filtroCc by remember { mutableStateOf("") }
    var filtroPosse by remember { mutableStateOf("") }
    val ordem = rememberOrdem("NOME")
    val scope = rememberCoroutineScope()
    if (d.podeEditar) {
        CartaoSecao(titulo = "Novo equipamento ou ferramenta", subtitulo = "Entra na lista de patrimônio da obra.") {
            Par(largo,
                { m -> Campo("Equipamento", nome, modifier = m, onChange = { nome = it }) },
                { m -> Campo("Identificação / placa", ident, modifier = m, onChange = { ident = it }) }
            )
            Par(largo,
                { m -> Seletor("Posse", listOf("PROPRIO" to "Próprio", "ALUGADO" to "Alugado"), posse, { posse = it }, modifier = m, embutido = true) },
                { m -> Campo("Empresa (se alugado)", empresa, modifier = m, onChange = { empresa = it }) }
            )
            SeletorBusca("Centro de custo", d.centros.map { it.id to it.rotulo }, cc, { cc = it }, embutido = true)
            msg?.let { Text(it, color = if (it.startsWith("Falha")) PortalCores.Vermelho else PortalCores.Verde) }
            PortalButton(onClick = {
                val body = "{\"nome\":${js(nome)},\"identificacao\":${js(ident)},\"posse\":${js(posse)},\"empresa\":${js(empresa)},\"ccCodigo\":${js(cc)},\"tipo\":\"EQUIPAMENTO\"}"
                scope.launch {
                    AuthApi.apiJson("POST", "/estoque/patrimonio", body)
                        .onSuccess { nome = ""; ident = ""; msg = "Equipamento gravado."; onOk() }
                        .onFailure { msg = it.message ?: "Falha ao gravar." }
                }
            }, enabled = nome.isNotBlank()) { Text("Salvar equipamento") }
        }
    }
    val termos = busca.trim().split(Regex("\\s+")).filter { it.isNotEmpty() }
    val filtrados = d.patrimonio.filter { p ->
        (filtroCc.isBlank() || p.cc == filtroCc) &&
            (filtroPosse.isBlank() || p.posse.equals(filtroPosse, true)) &&
            termos.all { t ->
                Ordenacao.contem(p.nome, t) || Ordenacao.contem(p.identificacao, t) ||
                    Ordenacao.contem(rotuloPosse(p.posse), t) || Ordenacao.contem(p.empresa, t) ||
                    Ordenacao.contem(p.cc, t) || Ordenacao.contem(p.obra, t) ||
                    Ordenacao.contem(p.situacao, t) || Ordenacao.contem(dataBr(p.chegada), t) ||
                    Ordenacao.contem(p.contrato, t)
            }
    }
    val cmp = when (ordem.col) {
        "ID" -> Ordenacao.por(ordem.asc) { it: EstPat -> it.identificacao }
        "POSSE" -> Ordenacao.por(ordem.asc) { it: EstPat -> rotuloPosse(it.posse) }
        "EMP" -> Ordenacao.por(ordem.asc) { it: EstPat -> it.empresa }
        "CC" -> Ordenacao.por(ordem.asc) { it: EstPat -> it.cc }
        "OBRA" -> Ordenacao.por(ordem.asc) { it: EstPat -> it.obra }
        "CHEG" -> Ordenacao.por(ordem.asc) { it: EstPat -> it.chegada }
        "SIT" -> Ordenacao.por(ordem.asc) { it: EstPat -> it.situacao }
        else -> Ordenacao.por(ordem.asc) { it: EstPat -> it.nome }
    }
    val linhas = filtrados.sortedWith(if (ordem.col == "NOME") cmp else cmp.thenBy { it.nome })
    val temFiltro = busca.isNotBlank() || filtroCc.isNotBlank() || filtroPosse.isNotBlank()
    val posses = d.patrimonio.map { it.posse }.filter { it.isNotBlank() }.distinct().sorted()
    CartaoSecao(titulo = "Patrimônio nas obras", subtitulo = "Equipamento, identificação, posse, empresa, obra e situação em colunas.") {
        Campo("Buscar equipamento, placa, empresa ou obra", busca) { busca = it }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            Box(Modifier.weight(1.4f)) {
                Seletor("Centro de custo", listOf("" to "Todos os centros") + d.centros.map { it.id to it.rotulo }, filtroCc, { filtroCc = it }, embutido = true)
            }
            Box(Modifier.weight(1f)) {
                Seletor("Posse", listOf("" to "Todas") + posses.map { it to rotuloPosse(it) }, filtroPosse, { filtroPosse = it }, embutido = true)
            }
        }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
            Text("${linhas.size} de ${d.patrimonio.size}", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
            if (temFiltro) TextButton(onClick = { busca = ""; filtroCc = ""; filtroPosse = "" }) { Text("Limpar filtros") }
        }
        Box(Modifier.fillMaxWidth().horizontalScroll(rememberScrollState())) {
            Column(Modifier.width(if (d.podeExcluir) 1480.dp else 1380.dp)) {
                TabelaPortal(cabecalho = {
                    CelulaCabecalhoOrdenavel("Equipamento", 2.4f, ordem.marca("NOME")) { ordem.clique("NOME") }
                    CelulaCabecalhoOrdenavel("Identificação", 1.4f, ordem.marca("ID")) { ordem.clique("ID") }
                    CelulaCabecalhoOrdenavel("Posse", 0.8f, ordem.marca("POSSE")) { ordem.clique("POSSE") }
                    CelulaCabecalhoOrdenavel("Empresa", 1.5f, ordem.marca("EMP")) { ordem.clique("EMP") }
                    CelulaCabecalhoOrdenavel("CC", 0.5f, ordem.marca("CC")) { ordem.clique("CC") }
                    CelulaCabecalhoOrdenavel("Obra", 2.0f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
                    CelulaCabecalhoOrdenavel("Chegada", 0.9f, ordem.marca("CHEG")) { ordem.clique("CHEG") }
                    CelulaCabecalhoOrdenavel("Situação", 0.8f, ordem.marca("SIT")) { ordem.clique("SIT") }
                    if (d.podeExcluir) CelulaCabecalho("", 0.9f)
                }) {
                    if (linhas.isEmpty()) {
                        Text("Nenhum equipamento com esses filtros.", modifier = Modifier.padding(16.dp), color = PortalCores.CinzaTexto)
                    }
                    linhas.forEach { p ->
                        LinhaTabela {
                            Celula(p.nome, 2.4f, negrito = true, cor = PortalCores.Navy, linhas = 6)
                            Celula(p.identificacao.ifBlank { "—" }, 1.4f, linhas = 3)
                            Celula(rotuloPosse(p.posse), 0.8f)
                            Celula(p.empresa.ifBlank { "—" }, 1.5f, linhas = 3)
                            Celula(p.cc.ifBlank { "—" }, 0.5f)
                            Celula(p.obra.ifBlank { "—" }, 2.0f, linhas = 4)
                            Celula(dataBr(p.chegada), 0.9f)
                            Celula(p.situacao.ifBlank { "—" }, 0.8f)
                            if (d.podeExcluir) {
                                TextButton(
                                    onClick = { scope.launch { AuthApi.apiJson("DELETE", "/estoque/patrimonio/${p.id}").onSuccess { onOk() } } },
                                    modifier = Modifier.weight(0.9f), contentPadding = PaddingValues(horizontal = 0.dp, vertical = 4.dp)
                                ) { Text("Excluir", color = PortalCores.Vermelho, maxLines = 1, softWrap = false) }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun AbaHist(d: EstDados, onOk: () -> Unit) {
    var busca by remember { mutableStateOf("") }
    var tipo by remember { mutableStateOf("") }
    var cc by remember { mutableStateOf("") }
    val ordem = remember { OrdemColuna("DATA").apply { asc = false } }
    val scope = rememberCoroutineScope()
    val termos = busca.trim().split(Regex("\\s+")).filter { it.isNotEmpty() }
    val filtrados = d.movs.filter { m ->
        (tipo.isBlank() || m.tipo == tipo) &&
            (cc.isBlank() || m.cc == cc || m.destino.startsWith(cc)) &&
            termos.all { t ->
                Ordenacao.contem(m.item, t) || Ordenacao.contem(rotuloTipo(m.tipo), t) ||
                    Ordenacao.contem(qtdTxt(m.qtd), t) || Ordenacao.contem(m.cc, t) ||
                    Ordenacao.contem(m.obra, t) || Ordenacao.contem(m.destino, t) ||
                    Ordenacao.contem(m.responsavel, t) || Ordenacao.contem(dataBr(m.data), t) ||
                    Ordenacao.contem(m.data, t)
            }
    }
    val cmp = when (ordem.col) {
        "TIPO" -> Ordenacao.por(ordem.asc) { it: EstMov -> rotuloTipo(it.tipo) }
        "ITEM" -> Ordenacao.por(ordem.asc) { it: EstMov -> it.item }
        "QTD" -> Ordenacao.porNumero(ordem.asc) { it: EstMov -> it.qtd }
        "CC" -> Ordenacao.por(ordem.asc) { it: EstMov -> it.cc }
        "OBRA" -> Ordenacao.por(ordem.asc) { it: EstMov -> it.obra }
        "DEST" -> Ordenacao.por(ordem.asc) { it: EstMov -> it.destino }
        "RESP" -> Ordenacao.por(ordem.asc) { it: EstMov -> it.responsavel }
        else -> Ordenacao.por(ordem.asc) { it: EstMov -> it.data }
    }
    val linhas = filtrados.sortedWith(cmp.thenByDescending { it.data }.thenBy { it.item })
    val temFiltro = busca.isNotBlank() || tipo.isNotBlank() || cc.isNotBlank()
    val podeAlgum = d.podeExcluir && d.movs.any { !it.id.startsWith("mv_") }
    CartaoSecao(
        titulo = "Movimentos",
        subtitulo = "Data, tipo, item, quantidade, obra e responsável separados. Clique no título da coluna para ordenar."
    ) {
        Campo("Buscar item, obra, responsável ou data", busca) { busca = it }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
            Box(Modifier.weight(1f)) {
                Seletor(
                    "Tipo",
                    listOf("" to "Todos", "ENTRADA" to "Entrada", "SAIDA" to "Saída", "TRANSFERENCIA" to "Transferência"),
                    tipo, { tipo = it }, embutido = true
                )
            }
            Box(Modifier.weight(1.5f)) {
                Seletor("Centro de custo", listOf("" to "Todos os centros") + d.centros.map { it.id to it.rotulo }, cc, { cc = it }, embutido = true)
            }
        }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
            Text("${linhas.size} de ${d.movs.size}", color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
            if (temFiltro) TextButton(onClick = { busca = ""; tipo = ""; cc = "" }) { Text("Limpar filtros") }
        }
        Box(Modifier.fillMaxWidth().horizontalScroll(rememberScrollState())) {
            Column(Modifier.width(if (podeAlgum) 1500.dp else 1400.dp)) {
                TabelaPortal(cabecalho = {
                    CelulaCabecalhoOrdenavel("Data", 0.9f, ordem.marca("DATA")) { ordem.clique("DATA") }
                    CelulaCabecalhoOrdenavel("Tipo", 0.95f, ordem.marca("TIPO")) { ordem.clique("TIPO") }
                    CelulaCabecalhoOrdenavel("Item", 2.4f, ordem.marca("ITEM")) { ordem.clique("ITEM") }
                    CelulaCabecalhoOrdenavel("Qtd", 0.5f, ordem.marca("QTD")) { ordem.clique("QTD") }
                    CelulaCabecalhoOrdenavel("CC", 0.5f, ordem.marca("CC")) { ordem.clique("CC") }
                    CelulaCabecalhoOrdenavel("Obra", 1.8f, ordem.marca("OBRA")) { ordem.clique("OBRA") }
                    CelulaCabecalhoOrdenavel("Destino", 1.6f, ordem.marca("DEST")) { ordem.clique("DEST") }
                    CelulaCabecalhoOrdenavel("Responsável", 1.4f, ordem.marca("RESP")) { ordem.clique("RESP") }
                    if (podeAlgum) CelulaCabecalho("", 0.9f)
                }) {
                    if (linhas.isEmpty()) {
                        Text("Nenhum movimento com esses filtros.", modifier = Modifier.padding(16.dp), color = PortalCores.CinzaTexto)
                    }
                    linhas.forEach { m ->
                        val corTipo = when (m.tipo) {
                            "ENTRADA" -> PortalCores.Verde
                            "SAIDA" -> PortalCores.Vermelho
                            else -> PortalCores.Navy
                        }
                        LinhaTabela {
                            Celula(dataBr(m.data), 0.9f)
                            Celula(rotuloTipo(m.tipo), 0.95f, negrito = true, cor = corTipo)
                            Celula(m.item.ifBlank { "—" }, 2.4f, negrito = true, cor = PortalCores.Navy, linhas = 4)
                            Celula(qtdTxt(m.qtd), 0.5f, negrito = true)
                            Celula(m.cc.ifBlank { "—" }, 0.5f)
                            Celula(m.obra.ifBlank { "—" }, 1.8f, linhas = 3)
                            Celula(m.destino.ifBlank { "—" }, 1.6f, linhas = 3)
                            Celula(m.responsavel.ifBlank { "—" }, 1.4f, linhas = 2)
                            if (podeAlgum) {
                                if (!m.id.startsWith("mv_")) {
                                    TextButton(
                                        onClick = { scope.launch { AuthApi.apiJson("DELETE", "/estoque/mov/${m.id}").onSuccess { onOk() } } },
                                        modifier = Modifier.weight(0.9f), contentPadding = PaddingValues(horizontal = 0.dp, vertical = 4.dp)
                                    ) { Text("Excluir", color = PortalCores.Vermelho, maxLines = 1, softWrap = false) }
                                } else Celula("", 0.9f)
                            }
                        }
                    }
                }
            }
        }
    }
}
